import React from 'react';
import PropTypes from 'prop-types';
import { IntroductionPageView } from '../../shared/components/IntroductionPageView';
import { introductionPageText } from '../definitions/constants';

const ombInfo = {
  resBurden: '15',
  ombNumber: '2900-0666',
  expDate: '02/28/2029',
};

const SIGN_IN_URL = '/sign-in/';

const PrimaryEntryLink = ({ href, onClick, children }) => (
  <va-link-action
    href={href === '#start' ? SIGN_IN_URL : href}
    onClick={onClick}
    text={children}
    type="primary-entry"
  />
);

PrimaryEntryLink.propTypes = {
  children: PropTypes.node.isRequired,
  href: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

export const IntroductionPage = ({ route }) => {
  const content = {
    formTitle: introductionPageText.formTitle,
    formSubTitle: introductionPageText.formSubTitle,
    authStartFormText: introductionPageText.authStartFormText,
    saveInProgressText: introductionPageText.saveInProgressText,
    unauthStartText: introductionPageText.unauthStartText,
    unauthStartLinkText: introductionPageText.unauthStartLinkText,
    customLink: PrimaryEntryLink,
    hideSipIntro: false,
  };

  const renderBoldTrailingConjunction = text => {
    const match = text.match(/^(.*?)(,?\s(?:or|and))$/);

    if (!match) {
      return text;
    }

    const [, baseText, conjunction] = match;

    return (
      <>
        {baseText}
        <strong>{conjunction}</strong>
      </>
    );
  };

  const childContent = (
    <>
      <p className="va-introtext">{introductionPageText.intro}</p>

      <h2 className="vads-u-font-size--h2 vads-u-margin-bottom--1">
        {introductionPageText.getStartedHeader}
      </h2>

      <va-process-list>
        <va-process-list-item
          header={introductionPageText.eligibilityHeader}
          level={3}
        >
          <p>{introductionPageText.eligibilityIntro}</p>
          <ul>
            {introductionPageText.eligibilityItems.map(item => {
              const itemText = typeof item === 'string' ? item : item.text;

              return (
                <li key={itemText}>
                  {renderBoldTrailingConjunction(itemText)}

                  {item.subItems?.length ? (
                    <ul>
                      {item.subItems.map(subItem => (
                        <li key={subItem}>
                          {renderBoldTrailingConjunction(subItem)}
                        </li>
                      ))}
                    </ul>
                  ) : null}
                </li>
              );
            })}
          </ul>

          <h4 className="vads-u-margin-top--3 vads-u-margin-bottom--1">
            {introductionPageText.spouseNote.label}
          </h4>
          <p>{introductionPageText.spouseNote.text}</p>

          <ul>
            {introductionPageText.spouseNote.spouseItems.map(item => {
              return <li key={item}>{renderBoldTrailingConjunction(item)}</li>;
            })}
          </ul>
        </va-process-list-item>

        <va-process-list-item
          header={introductionPageText.whatYouNeedHeader}
          level={3}
        >
          <p>{introductionPageText.whatYouNeedText}</p>
          <ul>
            {introductionPageText.whatYouNeedItems.map(item => (
              <li key={item.label}>
                <strong>{item.label}:</strong> {item.text}
              </li>
            ))}
          </ul>
        </va-process-list-item>

        <va-process-list-item
          header={introductionPageText.startHeader}
          level={3}
        >
          <p>{introductionPageText.startBody}</p>
          <p>{introductionPageText.startBodyCont}</p>

          <va-additional-info trigger={introductionPageText.afterApply.trigger}>
            <p>{introductionPageText.afterApply.firstParagraph}</p>
            <p>
              {introductionPageText.afterApply.secondParagraphStart}{' '}
              <va-telephone contact="8772228387" /> ({' '}
              <va-telephone contact="711" tty />
              ). {introductionPageText.afterApply.secondParagraphEnd}
            </p>
          </va-additional-info>
        </va-process-list-item>
      </va-process-list>
    </>
  );

  return (
    <IntroductionPageView
      route={route}
      content={content}
      ombInfo={ombInfo}
      childContent={childContent}
    />
  );
};

IntroductionPage.propTypes = {
  route: PropTypes.shape({
    formConfig: PropTypes.shape({}),
    pageList: PropTypes.array,
  }),
};

export default IntroductionPage;
